import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators
} from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ValidationMessage, ValidationPattern } from '../../directives/validation.directive';
import { IUserWithAnagraphic } from '../../models/request-and-responses/rest-api/interfaces/userWithAnagraphic';
import { catchError, map, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

export enum ResetPasswordParams {
    UserId = 'userId',
    Token = 'token'
}

enum Controls {
    Password1 = 'password1',
    Password2 = 'password2'
}
enum ConfirmPasswordValidatorsNames {
    MatchPassword = 'matchPasswordValidator',
    StrongPassword = 'strongPasswordValidator'
}
enum ConfirmPasswordErrorsNames {
    MatchPassword = 'matchPasswordValidator',
    StrongPassword = 'strongPasswordValidator'
}

export class ConfirmPasswordValidators {
    static [ConfirmPasswordValidatorsNames.MatchPassword](
        control: AbstractControl
    ): ValidationErrors | null {
        const pw1FC = control.get(Controls.Password1);
        const pw2FC = control.get(Controls.Password2);
        if (pw1FC != null && pw2FC != null) {
            if ((pw1FC.value.length || pw2FC.value.length) && pw1FC.value !== pw2FC.value) {
                return { [ConfirmPasswordErrorsNames.MatchPassword]: true };
            }
            return null;
        }
    }

    static [ConfirmPasswordValidatorsNames.StrongPassword](
        control: AbstractControl
    ): ValidationErrors | null {
        const regexp = new RegExp(ValidationPattern.password);
        if (regexp.test(control.value) === false) {
            return { [ConfirmPasswordErrorsNames.StrongPassword]: true };
        }
        return null;
    }
}

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css']
})
export class PasswordResetComponent implements OnInit {
    passwordMessage = ValidationMessage.password;
    passwordResetToken: string;
    userId: string;
    user: IUserWithAnagraphic;

    passwordFormGroup = new FormGroup(
        {
            [Controls.Password1]: new FormControl('', [
                Validators.required,
                ConfirmPasswordValidators.strongPasswordValidator
            ]),
            [Controls.Password2]: new FormControl('', [Validators.required])
        },
        ConfirmPasswordValidators.matchPasswordValidator
    );
    constructor(
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private authService: AuthService,
        private router: Router
    ) {
        this.activatedRoute.queryParams.subscribe(response => {
            this.passwordResetToken = response[ResetPasswordParams.Token];
            this.userId = response[ResetPasswordParams.UserId];
            if (this.passwordResetToken == null || this.userId == null) {
                this.toastr.error('Non è possibile modificare la password', 'Errore', {
                    closeButton: true,
                    disableTimeOut: true
                });
                //TODO: mandare una nuova mail / notificare superiori
            } else {
                this.identifyUser();
            }
        });
    }

    ngOnInit() {}

    private identifyUser(): void {
        this.authService
            .identifyUserByResetPasswordToken(this.userId, this.passwordResetToken)
            .pipe(
                map(response => response.item),
                tap(user => {
                    this.user = user;
                }),
                catchError(err => {
                    console.error(err);
                    return EMPTY;
                })
            )
            .subscribe();
    }

    doResetPassword() {
        const newPasswordJSON = `"${this.passwordFormGroup.controls[Controls.Password1].value}"`;
        this.authService
            .resetPassword(this.userId, this.passwordResetToken, newPasswordJSON)
            .subscribe(() => {
                this.toastr.success('La password è stata cambiata', 'Successo', {
                    disableTimeOut: true,
                    closeButton: true
                });
                this.router.navigate(['']);
            });
    }

    get isThereMachPasswordError(): boolean {
        const errors: ValidationErrors = this.passwordFormGroup.errors;
        return errors != null && errors[ConfirmPasswordErrorsNames.MatchPassword] === true;
    }

    get isThereStrongPasswordError(): boolean {
        const errors: ValidationErrors = this.passwordFormGroup.controls[Controls.Password1].errors;
        return errors != null && errors[ConfirmPasswordErrorsNames.StrongPassword] === true;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/password-reset/password-reset.component.ts